import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'
import { List, useListRepository } from 'elentari'
import { cenarioRepository } from './CenarioRepository'
import { useAbility } from '../Usuarios'
import { Tooltip } from 'recharts'
import { Fab } from '@material-ui/core'
import { getListActions } from '../../lib/crudAuthorization'
import { formatCurrency } from '../../utils/Formatter'

export const CenarioTable = ({ classes, onClickNew, ...props }) => {
  const history = useHistory()

  const listHook = useListRepository({
    repository: cenarioRepository,
    path: 'cenarios'
  })

  const [ability] = useAbility()
  const actions = getListActions(ability, listHook, 'cenarios')

  const listOptions = {
    defaultOrder: 'id',
    fields: {
      id: {
        label: 'Id'
      },
      descricao: {
        label: 'Descrição do Cenário'
      },
      valorInicial: {
        label: 'Valor inicial',
        format: valorInicial => formatCurrency(valorInicial)
      },
      valorFinal: {
        label: 'Valor final',
        format: valorInicial => formatCurrency(valorInicial)
      },
      risco: {
        label: 'Risco',
        format: risco => `${risco.numero} - ${risco.descricao}`,
        noOrder: true
      },
      prazoRenovacao: {
        label: 'Prazo de Renovação'
      }
    }
  }

  const handleClickEdit = cenario =>
    history.push(`/cenarios/${cenario.id}${history.location.search}`)

  return (
    <Fragment>
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickEdit={handleClickEdit}
        onClickView={null}
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
      <Tooltip title="Adicionar">
        <Fab
          aria-label="Adicionar"
          color="primary"
          onClick={onClickNew}
          size="small"
        >
          <AddIcon size={24} color="inherit" />
        </Fab>
      </Tooltip>
    </Fragment>
  )
}
